import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "filter-container" }
const _hoisted_2 = { class: "list-container" }
const _hoisted_3 = { class: "title" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FilterSuiviFacture = _resolveComponent("FilterSuiviFacture")!
  const _component_LoaderComponent = _resolveComponent("LoaderComponent")!
  const _component_ReglePastille = _resolveComponent("ReglePastille")!
  const _component_DataTable = _resolveComponent("DataTable")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_FilterSuiviFacture, {
        comparisonList: _ctx.comparisonList,
        filter: _ctx.filter,
        onClearFilter: _ctx.clearFilter,
        onComparison: _ctx.setComparison,
        onSearch: _ctx.search,
        onSetDateFrom: _ctx.setDateFrom,
        onSetDateTo: _ctx.setDateTo,
        onSetEtablissement: _ctx.setEtablissement,
        onSetFournisseur: _ctx.setFournisseur,
        onSetMontant: _ctx.setMontant,
        onSetNumeroFacture: _ctx.setNumeroFacture,
        onSetSociete: _ctx.setSociete
      }, null, 8, ["comparisonList", "filter", "onClearFilter", "onComparison", "onSearch", "onSetDateFrom", "onSetDateTo", "onSetEtablissement", "onSetFournisseur", "onSetMontant", "onSetNumeroFacture", "onSetSociete"])
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h2", _hoisted_3, [
        (_ctx.tableData && _ctx.tableData.length > 0 && !_ctx.isFilterLoading)
          ? (_openBlock(), _createElementBlock("span", _hoisted_4, [
              (_ctx.isFiltered && _ctx.totalCount > 0)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createTextVNode(_toDisplayString(_ctx.$t('facture.avantEcheance.filtre', { count: +_ctx.count })) + " / " + _toDisplayString(_ctx.$t('facture.avantEcheance.title', { count: +_ctx.totalCount })), 1)
                  ], 64))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _createTextVNode(_toDisplayString(_ctx.$t('facture.avantEcheance.title', { count: +_ctx.count })), 1)
                  ], 64))
            ]))
          : (_ctx.isFilterLoading && _ctx.tableData.length > 0)
            ? (_openBlock(), _createElementBlock("span", _hoisted_5, [
                _createVNode(_component_LoaderComponent)
              ]))
            : _createCommentVNode("", true),
        _createVNode(_component_ReglePastille, { cle: "facturation.perimetreChantiers" }),
        _createVNode(_component_ReglePastille, { cle: "facturation.compteurFiltre" }),
        _createVNode(_component_ReglePastille, { cle: "facturation.defilementInfini" }),
        _createVNode(_component_ReglePastille, { cle: "facturation.triLocal" }),
        _createVNode(_component_ReglePastille, { cle: "facturation.echeanceFenetreFixe" })
      ]),
      _createElementVNode("div", {
        ref: "content",
        class: "datatable",
        onScroll: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handleScroll && _ctx.handleScroll(...args)))
      }, [
        (_ctx.isLoading && _ctx.tableData.length === 0)
          ? (_openBlock(), _createBlock(_component_LoaderComponent, { key: 0 }))
          : (_openBlock(), _createBlock(_component_DataTable, {
              key: 1,
              count: +_ctx.count,
              tableHeader: _ctx.tableHeader,
              tableData: _ctx.tableData || [],
              isLoading: _ctx.isLoading,
              noDataText: _ctx.$t('facture.avantEcheance.noData'),
              "stop-propa-on-pdf": true,
              onDownloadPdf: _ctx.downloadPdf,
              onSelect: _ctx.downloadPdf,
              onSort: _ctx.handleSort
            }, null, 8, ["count", "tableHeader", "tableData", "isLoading", "noDataText", "onDownloadPdf", "onSelect", "onSort"]))
      ], 544)
    ])
  ], 64))
}